import styled from "@emotion/styled";
import { color } from "metabase/lib/colors";

export const EmbedTitleLabel = styled.span`
  &:hover {
    color: ${color("brand")};
  }
`;
